app.controller('IndexController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $rootScope.service.cache_local_server.initCache();
    $rootScope.site_shared.triggerIndexInit();


    $rootScope.service.order.initCachedOrder();

    $rootScope.navigation_manager.initNavigation();


    $rootScope.service.account.requireUserData(function () {

        if ($rootScope.service.staff.isSelectCustomerRequired()) {
            $state.go('myba.staff-customer');
        }
        // $rootScope.service.menu.setCartVisible(true) //todo temp

    });

    function onStateChange() {
        if ($rootScope.service.account.isRouteDenied(window.location.pathname)) {
            $state.go('myba.dashboard');
        }
    }

    $rootScope.$on('$stateChangeSuccess', function ($event, next, current) {
        onStateChange();
    });

    onStateChange();

}]);